'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarkdownItConfiguration = exports.linkifiedMarkdownItConfiguration = exports.defaultMarkdownItConfiguration = exports.MarkdownItExtended = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _markdownIt = require('markdown-it');

var _markdownIt2 = _interopRequireDefault(_markdownIt);

var _markdownItForInline = require('markdown-it-for-inline');

var _markdownItForInline2 = _interopRequireDefault(_markdownItForInline);

var _markdownItEmoji = require('markdown-it-emoji');

var _markdownItEmoji2 = _interopRequireDefault(_markdownItEmoji);

var _injectParagraphSpacesIntoTokens = require('./injectParagraphSpacesIntoTokens');

var _injectParagraphSpacesIntoTokens2 = _interopRequireDefault(_injectParagraphSpacesIntoTokens);

var _generateIdsOnTokens = require('./generateIdsOnTokens');

var _generateIdsOnTokens2 = _interopRequireDefault(_generateIdsOnTokens);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setLinkify = function setLinkify(markdownConfiguration, isLinkifyEnabled) {
  if (isLinkifyEnabled) {
    markdownConfiguration.enable("link", "linkify").set({ linkify: true });
    markdownConfiguration.linkify.set({ fuzzyIP: true });
  } else {
    markdownConfiguration.disable("link", "linkify").set({ linkify: false });
    markdownConfiguration.linkify.set({ fuzzyIP: false });
  }
};

var MarkdownItExtended = exports.MarkdownItExtended = function (_MarkdownIt) {
  _inherits(MarkdownItExtended, _MarkdownIt);

  function MarkdownItExtended() {
    _classCallCheck(this, MarkdownItExtended);

    return _possibleConstructorReturn(this, (MarkdownItExtended.__proto__ || Object.getPrototypeOf(MarkdownItExtended)).apply(this, arguments));
  }

  _createClass(MarkdownItExtended, [{
    key: 'parse',
    value: function parse() {
      var _get2;

      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }

      var parsedContent = (_get2 = _get(MarkdownItExtended.prototype.__proto__ || Object.getPrototypeOf(MarkdownItExtended.prototype), 'parse', this)).call.apply(_get2, [this].concat(props));
      parsedContent = (0, _injectParagraphSpacesIntoTokens2.default)(parsedContent);
      parsedContent = (0, _generateIdsOnTokens2.default)(parsedContent);

      return parsedContent;
    }
  }]);

  return MarkdownItExtended;
}(_markdownIt2.default);

var createConfiguredMarkdownIt = function createConfiguredMarkdownIt(isLinkifyEnabled) {
  var markdownit = new MarkdownItExtended("zero", {
    breaks: true,
    linkify: isLinkifyEnabled
  });

  markdownit.enable(["linkify", "link", "block", "inline", "paragraph", "list", "emphasis", "newline", "balance_pairs", "backticks", "strikethrough"]);

  markdownit.use(_markdownItForInline2.default, 'replace_asterisk_markup', 'text', function (tokens, idx) {
    tokens.filter(function (x) {
      return x.markup === '*' && x.tag === 'em';
    }).forEach(function (token) {
      token.tag = 'strong';
      token.type = token.type === 'em_open' ? 'strong_open' : 'strong_close';
      token.markup = '**';
    });
  });

  markdownit.use(_markdownItEmoji2.default);

  setLinkify(markdownit, isLinkifyEnabled);

  return markdownit;
};

var defaultMarkdownItConfiguration = exports.defaultMarkdownItConfiguration = createConfiguredMarkdownIt(false);
var linkifiedMarkdownItConfiguration = exports.linkifiedMarkdownItConfiguration = createConfiguredMarkdownIt(true);

var getMarkdownItConfiguration = exports.getMarkdownItConfiguration = function getMarkdownItConfiguration(isLinkifyEnabled) {
  return isLinkifyEnabled ? linkifiedMarkdownItConfiguration : defaultMarkdownItConfiguration;
};